"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const OkayVimeoCore_1 = __importDefault(require("./OkayVimeoCore"));
const React = __importStar(require("react"));
const react_1 = require("react");
const OkayVimeo = (props) => {
    const [total, setTotal] = react_1.useState(0);
    const onProgressChanged = (progress) => {
        props.onCurrentTimeChanged(progress.seconds);
        props.onTotalTimeChanged(progress.duration);
        setTotal(progress.duration);
    };
    return (React.createElement(OkayVimeoCore_1.default, { src: `https://vimeo.com/${props.vimeoId}`, id: props.vimeoId, isPlaying: props.isPlaying, targetCurrent: props.targetCurrent, speckerOn: !props.isMuted, onProgressChanged: onProgressChanged, onIsPlayingChanged: () => { }, onSpeakerOnChanged: () => { }, onEnded: props.onEnded }));
};
exports.default = OkayVimeo;
//# sourceMappingURL=OkayVimeo.js.map